"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiBenefitRenewal {
    static getBenefitRenewal(token) {
        let url = `/renewal`;
        return Client_1.default.httpGet(url, token);
    }
    static getBenefitRenewalDocumentSummary(token) {
        let url = `/renewal/document`;
        return Client_1.default.httpGet(url, token);
    }
    static getBenefitRenewalOpenEnrollment(token) {
        let url = `/renewal/openenrollment`;
        return Client_1.default.httpGet(url, token);
    }
    static getBenefitRenewalSigning(token) {
        let url = `/renewal/signing`;
        return Client_1.default.httpGet(url, token);
    }
    static getLocations(token) {
        let url = `/renewal/locations`;
        return Client_1.default.httpGet(url, token);
    }
    static exportOpenEnrollmentCsv(token) {
        let url = `/renewal/openenrollment/export`;
        return Client_1.default.httpGetText(url, token);
    }
    static getOpenEnrollmentCsvExportDownload(token) {
        const path = `/renewal/openenrollment/export`;
        return {
            url: Client_1.default.buildUrl(path),
            headers: Client_1.default.buildHeaders(token, { Accept: 'text/csv, text/plain, */*' }),
        };
    }
}
exports.default = ApiBenefitRenewal;
